import { Component } from '@angular/core';



@Component({
    selector: '[gpis-spa]',
    templateUrl: '../views/masterpage.html',
    
})

 export class AppComponent
 {

 }



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/app.component.ts